import { RuleGroupType } from 'react-querybuilder';

export interface DogBreed {
  id: string;
  name: string;
  group?: string;
}

export interface CatBreed {
  id: string;
  name: string;
  origin?: string;
  temperament?: string;
}

export type PetType = 'dog' | 'cat';

export interface Filter {
  id: string;
  field: string;
  label: string;
  type: 'select' | 'number' | 'text' | 'date';
  options?: Array<{ value: string; label: string }>;
}

export enum TriggerCategory {
  Environmental = 'environmental',
  Time = 'time',
  Metric = 'metric'
}

export interface Trigger {
  id: string;
  name: string;
  category: TriggerCategory;
  field: string;
  label: string;
  type: 'select' | 'number' | 'text' | 'date' | 'boolean';
  options?: Array<{ value: string | number; label: string }>;
  unit?: string;
}

export interface Notification {
  id: string;
  topic: string;
  body: string;
  priority?: 'low' | 'medium' | 'high';
  channels?: Array<'push' | 'email' | 'sms'>;
}

export interface Rule {
  id: string;
  name: string;
  description?: string;
  filters: RuleGroupType;
  triggers: RuleGroupType;
  notification: Notification;
  active: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface RuleEngine {
  rules: Rule[];
  filters: Filter[];
  triggers: Trigger[];
}

export interface JsonLogicRule {
  filters?: any;
  triggers?: any;
  notification: Notification;
  metadata?: {
    id: string;
    name: string;
    description?: string;
    active: boolean;
    createdAt: string;
    updatedAt: string;
  };
}